export default __webpack_public_path__ + "static/home_hero_image_desktop-ea39508631d1a3a589644410fcd634ed.png";